import { ComparatorStep } from '@kizi/comparator-core';

const startWidget: ComparatorStep = {
  path: 'start',
  name: 'startWidget',
  fields: [],
};

export default startWidget;
